<template>
    <div id="funny404">
      <transition-group name="langTrans" mode="out-in">
        <!-- --------------------- ENGLISH --------------------- -->
        <div v-if="english" class="inner" key="english">
          <div id="wrapper">
            <section id="main" class="wrapper">
              <div class="inner">
                <h1 class="major">
                  Funny
                  <span
                    class="lastname"
                    style="cursor: auto; border-bottom: none"
                  >
                    404
                  </span>
                </h1>
                <p>
                  A fun project i did is coding a 404 page referencing windows XP famous bug. It's
                  <a
                    href="https://github.com/Fraulk/Funny-404"
                    target="_blank"
                    rel="noreferrer noopener nofollow"
                    >open source</a
                  >
                  and based on this 
                  <a
                    href="https://dribbble.com/shots/12120514-Error-State-Illustration-3"
                    target="_blank"
                    rel="noreferrer noopener nofollow"
                    >dribbble project</a
                  >.<br /><br />
                  <a
                    href="https://funny-404.netlify.app/"
                    target="_blank"
                    rel="noreferrer noopener nofollow"
                    class="cta"
                    >Live Demo</a
                  >
                </p>
              </div>
            </section>
          </div>
        </div>
  
        <!-- --------------------- FRENCH --------------------- -->
        <div v-if="!english" class="inner" key="french">
          <div id="wrapper">
            <section id="main" class="wrapper">
              <div class="inner">
                <h1 class="major">
                  Funny
                  <span
                    class="lastname"
                    style="cursor: auto; border-bottom: none"
                  >
                    404
                  </span>
                </h1>
                <p>
                  Un projet amusant que j'ai codé est une page 404 référençant un bug connu de windows XP. C'est
                  <a
                    href="https://github.com/Fraulk/Wii-Menu"
                    target="_blank"
                    rel="noreferrer noopener nofollow"
                    >open source</a
                  >
                  et basée sur un 
                  <a
                    href="https://github.com/Fraulk/Wii-Menu"
                    target="_blank"
                    rel="noreferrer noopener nofollow"
                    >projet dribbble</a
                  >.<br /><br />
                  <a
                    href="https://wii-menu.netlify.app/#/"
                    target="_blank"
                    rel="noreferrer noopener nofollow"
                    >Live Demo</a
                  >
                </p>
              </div>
            </section>
          </div>
        </div>
      </transition-group>
    </div>
  </template>
  
  <script>
  export default {
    name: "WhoAmI",
    props: {
      english: Boolean,
    },
  };
  </script>